export const tooltipLabel = 'Assets in the request list. Please review the list and submit the request.';
export const searchTooltipText = 'Search by Asset ID';
